module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row p0010"
  }, [_c('div', {
    staticClass: "p1111"
  }, [_c('bo-select', {
    attrs: {
      "size": "lg",
      "value": 2,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p0111"
  }, [_c('bo-select', {
    attrs: {
      "size": "sm",
      "value": 1,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p0111"
  }, [_c('bo-select', {
    attrs: {
      "size": "lg",
      "theme": "underline",
      "value": 2,
      "options": _vm.options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p0111"
  }, [_c('bo-select', {
    ref: "test",
    style: ({
      marginTop: '20px'
    }),
    attrs: {
      "required": true,
      "value": 2,
      "options": _vm.options
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p1000 tl"
  }, [_c('button', {
    staticClass: "btn btn-tiny btn-primary-blank",
    on: {
      "click": _vm.getValue
    }
  }, [_vm._v("获取输入值")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tiny btn-primary-blank",
    on: {
      "click": function($event) {
        _vm.setState('wrong')
      }
    }
  }, [_vm._v("置为警告")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-tiny btn-primary-blank",
    on: {
      "click": function($event) {
        _vm.setState('pass')
      }
    }
  }, [_vm._v("置为通过")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e33b080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-select/demo.vue
// module id = 221
// module chunks = 20